import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import InputWithValidation from "../../../common/components/InputWithValidation";
import { clone } from "../../../common/utils/helper";
import { modifySelectedCred } from "../../../redux/actions/credActions";
import AuthHeaders from "./AuthHeaders"


const CustomHeaders = () => {
  const dispatch = useDispatch();

  const selectedCred = useSelector((state) => state.auth.selectedCred);

  useEffect(() => {}, [selectedCred]);



  const onFormChange = (e) => {
    const credentials = clone(selectedCred);

    const key = e.target.name;
    const value = e.target.value;
     
    credentials[key] = value;
    
    dispatch(modifySelectedCred(credentials));

  };



  return (
    <>
      <h4>Setup Custom Headers:</h4>
      <InputWithValidation
        fieldTitle={"Name"}
        fieldName={"name"}
        onChange={onFormChange}
        inputValue={selectedCred.name ? selectedCred.name : ""}
        maxChar={70}
        minChar={2}
        type="textfield"
      />
      <InputWithValidation
        fieldTitle={"Description"}
        fieldName={"description"}
        onChange={onFormChange}
        inputValue={selectedCred.description ? selectedCred.description : ""}
        maxChar={500}
        type="textarea"
        rows={5}
      />
      <br />
     <AuthHeaders />
    </>
  );
};
export default CustomHeaders;
